import { WidgetDataSource } from '../../../../../../../models';
import {
  Comparison,
  Widget,
  WidgetGroup,
} from '../../../../../../../providers/bridge-api/dashboard.service';
import { FieldService } from '../../../../../../../providers/storage-api/field.service';
import { Utils } from '../../../../../../../utils/utils';
import { WidgetChartOptions } from '../../../../widget-chart/widget-chart.component';
import { AiInsightPayloadParams } from './widget-ai-insights-point-selection.service';
import { WidgetPointSelection } from './widget-point-selection';

export class GaugePointSelection extends WidgetPointSelection {
  override assemblePayloadFromSelection(
    selectedPoints: any[],
    widget: Widget<WidgetChartOptions>,
    dataSource: WidgetDataSource,
    widgetGroup?: WidgetGroup,
    comparison?: Comparison
  ): AiInsightPayloadParams {
    const payload = super.assemblePayloadFromSelection(
      selectedPoints,
      widget,
      dataSource,
      widgetGroup,
      comparison
    );

    const { gaugeOptions } = widget.payload;

    for (let pointIdx = 0; pointIdx < selectedPoints.length; pointIdx++) {
      const point = selectedPoints[pointIdx];
      const bucket = payload.buckets[pointIdx];
      bucket.analytic_item_value = point.y;
      bucket.aggregate_rating_score = point.y;
    }

    payload.scene_params.metric_calculation = gaugeOptions.metric;
    payload.scene_params.best_rating_value = gaugeOptions.maxRating;
    payload.scene_params.worst_rating_value = gaugeOptions.minRating;
    payload.scene_params.rating_field = FieldService.getFieldLongName(widget.payload.analyticItem);

    switch (gaugeOptions.metric) {
      case 'nps':
        payload.scene_params.metric_calculation = 'rating';
        payload.scene_params.rating_score_high = 100;
        payload.scene_params.rating_score_low = -100;
        break;
      case 'box':
        payload.scene_params.rating_score_high = 100;
        payload.scene_params.rating_score_low = 0;
        payload.scene_params.box_options = `${Utils.titleCase(gaugeOptions.metricBoxType)}:${
          gaugeOptions.metricBoxSize
        }`;
        break;
      case 'avg':
        payload.scene_params.rating_score_high = gaugeOptions.maxRating;
        payload.scene_params.rating_score_low = gaugeOptions.minRating;
        break;
    }

    return payload;
  }
}
